module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('p', {
    staticClass: "TITLE"
  }, [_c('a', {
    attrs: {
      "id": "_idTOCAnchor-4"
    }
  }), _vm._v("With All Our Prayers")]), _vm._v(" "), _c('p', {
    staticClass: "SUBTITLE"
  }, [_vm._v("Walking with God "), _c('br'), _vm._v("through the Christian Year")]), _vm._v(" "), _c('p', {
    staticClass: "AUTHOR"
  }, [_vm._v("John B. Rogers Jr.")]), _vm._v(" "), _c('p', {
    staticClass: "COMPANY"
  }, [_vm._v("William B. Eerdmans Publishing Company"), _c('br'), _vm._v("Grand Rapids, Michigan / Cambridge, U.K.")]), _vm._v(" "), _c('p', {
    staticClass: "COPYRIGHT"
  }, [_vm._v("© 2015 John B. Rogers Jr."), _c('br'), _vm._v("All rights reserved"), _c('br'), _c('br'), _vm._v("Published 2015 by"), _c('br'), _vm._v("Wm. B. Eerdmans Publishing Co."), _c('br'), _vm._v("2140 Oak Industrial Drive N.E., Grand Rapids, Michigan 49505 /"), _c('br'), _vm._v("P.O. Box 163, Cambridge CB3 9PU U.K."), _c('br'), _c('br'), _vm._v("Printed in the United States of America")]), _vm._v(" "), _c('p', {
    staticClass: "LIBRARY"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "CIP"
  }, [_vm._v("Rogers, John B., 1941-"), _c('br'), _vm._v("With all our prayers: walking with God through the Christian year /"), _c('br'), _vm._v("John B. Rogers, Jr."), _c('br'), _vm._v("pages   cm"), _c('br'), _vm._v("ISBN 978-0-8028-7191-6 (pbk.: alk. paper)"), _c('br'), _vm._v("eISBN 978-1-4674-4322-7 (ePub)"), _c('br'), _vm._v("eISBN 978-1-4674-4282-4 (Kindle)"), _c('br'), _vm._v("1. Pastoral prayers. 2. Prayers. 3. Church year — Prayers and devotions."), _c('br'), _vm._v("4. Public worship. I. Title."), _c('br'), _c('br'), _vm._v("BV250.R65 2015"), _c('br'), _vm._v("264"), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("′")]), _vm._v(".13 — dc23"), _c('br'), _vm._v("                        2014040381")]), _vm._v(" "), _c('p', {
    staticClass: "URL"
  }, [_c('a', {
    attrs: {
      "href": "http://www.eerdmans.com",
      "target": "_blank"
    }
  }, [_vm._v("www.eerdmans.com")])]), _vm._v(" "), _c('p', {
    staticClass: "DEDICATION"
  }, [_vm._v("Dedicated to"), _c('br'), _c('br'), _vm._v("Covenant Presbyterian Church"), _c('br'), _vm._v("Charlotte, North Carolina"), _c('br'), _c('br'), _vm._v("First Presbyterian Church"), _c('br'), _vm._v("Shreveport, Louisiana"), _c('br'), _c('br'), _vm._v("Davidson College Presbyterian Church"), _c('br'), _vm._v("Davidson, North Carolina"), _c('br'), _c('br'), _vm._v("First Presbyterian Church"), _c('br'), _vm._v("Durham, North Carolina"), _c('br'), _c('br'), _vm._v("“I thank my God in all my remembrance of you, always in every prayer of mine for you all making my prayer with joy, thankful for your partnership in the gospel . . . And I am sure that God who began a good work in you will bring it to completion at the day of Jesus Christ.”"), _c('br'), _vm._v("(Phil. 1:3-6, RSV)")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c732fdc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Rogers_With_All_Our_Prayers_text_CC.vue
// module id = 57
// module chunks = 0